import { updateAchDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: updateAchDepositSlice, asyncAction: updateAchDepositAction } = createAsyncSlice(
  'updateAchDepositSlice',
  updateAchDepositAsync
);
